import { render, staticRenderFns } from "./FbUpdateContactTech.vue?vue&type=template&id=0501ebc8"
import script from "./FbUpdateContactTech.vue?vue&type=script&lang=ts"
export * from "./FbUpdateContactTech.vue?vue&type=script&lang=ts"
import style0 from "./FbUpdateContactTech.vue?vue&type=style&index=0&id=0501ebc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports